import { useMutation } from '@tanstack/react-query'

import { generateBriefFromHtml } from '../api'

const useGenerateBriefFromHtmlMutation = () => {
  return useMutation({ mutationFn: generateBriefFromHtml })
}

export default useGenerateBriefFromHtmlMutation
